export default __webpack_public_path__ + "static/media/fb572dbc-f1ee-44ca-883e-088c704f543e.ed013076.woff2";